import './genericTotal.css'

export const defaultProps = {
  title: 'Etwas ist schiefgelaufen',
  text: `Beim Laden des Portals ist leider ein Fehler aufgetreten. Dieser wurde bereits automatisch an uns gemeldet.<br/><br/>
  Sollte der Fehler nach erneutem Laden weiterhin auftreten, kontaktieren Sie bitte unseren Support.`,
  action: 'javascript:window.location.reload()',
  actionText: 'Erneut versuchen',
  actionFallback: 'oauth/logout',
  actionFallbackText: 'Logout'
}

export default (pageProps) => {
  const props = Object.assign({ ...defaultProps }, pageProps)
  const actionFallbackLink = props.actionFallback ? `<a href="${props.actionFallback}" class="outline">${props.actionFallbackText}</a>` : ''
  const actionLink = `<a href="${props.action}">${props.actionText}</a>`

  return {
    template: `
      <div class="error-page-total generic">
        <div>
          <div class="logo-wrapper"></div>
          <h4>${props.title}</h4>
          <span>${props.text}</span>
          <div class="row">
            ${actionFallbackLink}
            ${actionLink}
          </div>
        </div>
      </div>`
  }

}